import { render } from "./CommonPublicView.vue?vue&type=template&id=3722180f&ts=true"
import script from "./CommonPublicView.vue?vue&type=script&lang=ts"
export * from "./CommonPublicView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__